import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
import { recaptchaSitekey } from "app/utils/const";
import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Recaptcha = ({ onVerify, onExpire }) => {
  const recaptchaRef = useRef(null);

  const resetRecaptcha = () => {
    if (recaptchaRef.current) {
      (recaptchaRef.current as ReCAPTCHA).reset();
    }
  };

  const handleVerify = (token: string) => {
    onVerify(token);
  };

  const handleExpire = () => {
    resetRecaptcha();
    onExpire();
  };

  return (
    <div className="auth-screen__form__recaptcha">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={recaptchaSitekey.prod}
        onChange={handleVerify}
        onExpired={handleExpire}
        hl={LanguageSelectionHelper.checkSelectedLanguage()}
      />
    </div>
  );
};

export default Recaptcha;
